import Vue from 'vue';
export default {
  data() {
    return {
      editInfoTabClass: 'menu-top-items active-tab',
      timeTabClass: 'menu-top-items',
      doctorInsideTabClass: 'menu-top-items',
      moreTabClass: 'menu-top-items',
      noteTabClass: 'menu-top-items',
      addressTabClass: 'menu-top-items',
      followUpDashboardDetailTab: 'mission',
      //mission Info
      missionAddress: '',
      missionCheifCompliant: '',
      missionCheifCompliantNote: '',
      listOfMissionCallerIds: [],
      listOfMissionLakeCodeStation: [],
      missionTagList: [],
      selectedMissionTag: null,
      //time
      missionTimes: '',
      stateDataTableItems: [],
      stateDataTableHeader: [],
      passedTimeFromCallInterval: null,
      passedTimeFromDispatchInterval: null,
      //note
      noteText: '',
      noteList: [],
      disabelNoteConfirm: false,
      //address
      addressDataTableHeader: [],
      addressDataTableItems: [],
      phoneOnlineLocationInterval: null,
      mapSingleMovingIconInterval: null,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      //admission
      admissionDataTableHeader: [],
      admissionDataTableItems: [],
      otherOrganDataTableHeader: [],
      otherOrganDataTableItems: [],
      //doctor
      allDoctorOrders: [],
      polyline: {
        latlngs: [],
        color: '#49454F',
      },
    };
  },
  methods: {
    showConfirmDialogFunction: function () {
      if (this.confimType == 'time') {
        this.$refs.confirm.title = 'ثبت زمان';
        this.$refs.confirm.text = 'از ثبت زمان اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'time') {
        this.disabelConfirm = true;
        this.SetTimeBy800();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'time') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    showSetTimeModal: function (type) {
      this.confimType = 'time';
      this.setTimeType = type;
      this.showConfirmDialogFunction();
    },
    SetTimeBy800: function () {
      if (this.setTimeType == 'moveFromStation') {
        this.setMoveFromStationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToLocation') {
        this.setArriveToLocationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'moveFromLocation') {
        this.setMoveFromLocationTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToHospital') {
        this.setArriveToHospitalTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'finish') {
        this.setFinishTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'patientDelivery') {
        this.setPatientDeliveryTimeFunction(this.missionPhoneId);
      } else if (this.setTimeType == 'arriveToStation') {
        this.setArriveToStationTimeFunction(this.missionPhoneId);
      }

      setTimeout(() => {
        if (this.$root.$refs.FollowUpMissionsDashboard) {
          this.$root.$refs.FollowUpMissionsDashboard?.fCodeListFollowUp();
        }
      }, 3000);
    },




    loadFollowUpDashboardDetail: function (temp) {
      this.missionAddress = temp.mission && temp.mission.address ? temp.mission.address : '-';
      this.missionCheifCompliant =
        temp.mission && temp.mission.chiefComplaintText ? temp.mission.chiefComplaintText : '-';
      this.missionCheifCompliantNote =
        temp.mission && temp.mission.chiefComplaintNote ? temp.mission.chiefComplaintNote : '-';
      if (temp.mission) {
        for (let i = 0; i < temp.mission.missionTags.length; i++) {
          this.missionTagList.push({
            title: temp.mission.missionTags[i].tag.title,
            id: temp.mission.missionTags[i].tag.id,
            missionTagId: temp.mission.missionTags[i].id,
          });
        }
        for (let i = 0; i < temp.mission.missionLackOfCodes.length; i++) {
          this.listOfMissionLakeCodeStation.push({
            title: temp.mission.missionLackOfCodes[i].station.title,
            titleCode: temp.mission.missionLackOfCodes[i].station.title + "(" + temp.mission.missionLackOfCodes[i].station.code + ")",
            id: temp.mission.missionLackOfCodes[i].station.id,
          });
        }
        for (let i = 0; i < temp.mission.callerIds.length; i++) {
          this.listOfMissionCallerIds.push(temp.mission.callerIds[i]);
        }
        if (temp.mission.latitude) {
          this.patiantPosition = {
            lat: temp.mission.latitude,
            lng: temp.mission.longitude,
          };
        }
      }
    },
    changeTab: function (title) {
      if (title == 'mission') {
        this.editInfoTabClass = 'menu-top-items active-tab';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.followUpDashboardDetailTab = 'mission';
      } else if (title == 'time') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items active-tab';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
        this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.followUpDashboardDetailTab = 'time';
      } else if (title == 'doctor') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items active-tab';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.followUpDashboardDetailTab = 'doctor';
        this.getAllPatientDoctorDetailFunction(this.missionPhoneId);
      } else if (title == 'moreInfo') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items active-tab';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.followUpDashboardDetailTab = 'moreInfo';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.getMissionPhoneOtherOrganizationFunction(this.missionId);
        this.getMissionPhoneAdmissionHistoryFunction(this.missionPhoneId);
      } else if (title == 'note') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items active-tab';
        this.addressTabClass = 'menu-top-items';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.noteText = '';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.followUpDashboardDetailTab = 'note';
      } else if (title == 'address') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items active-tab';
        clearInterval(this.passedTimeFromCallInterval);
        clearInterval(this.passedTimeFromDispatchInterval);
        clearInterval(this.mapSingleMovingIconInterval);
        this.getAllMissionAddressLogFunction(this.missionId);
        this.getPhoneOnlineLocationFunction(this.phoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
        this.mapSingleMovingIconInterval = setInterval(() => {
          this.getPhoneOnlineLocationFunction(this.phoneId);
        }, 4000);
        this.followUpDashboardDetailTab = 'address';
      }
    },
    addMissionTag: function () {
      let flag = false;
      if (this.missionTagList.length > 0) {
        for (let i = 0; i < this.missionTagList.length; i++) {
          if (this.missionTagList[i].id == this.selectedMissionTag.id) {
            flag = true;
          }
        }
      }
      if (flag == false) {
        this.addToMissionTagByAdmissionFunction(this.missionId, this.selectedMissionTag.id);
      } else {
        this.snackText = 'برچسب قبلا اضافه شده است';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }
    },
    missionAddedTag: function (data) {
      this.missionTagList.push({
        title: data.tag ? data.tag.title : '-',
        id: data.tag ? data.tag.id : null,
        missionTagId: data.id,
      });
      this.selectedMissionTag = null;
    },
    removeMissionTag: function (id) {
      this.removeTagFromMissionByAdmissionFunction(id);
    },
    missionRemoveTag: function (id) {
      for (let i = 0; i < this.missionTagList.length; i++) {
        if (this.missionTagList[i].missionTagId == id) {
          this.missionTagList.splice(i, 1);
        }
      }
    },
    //time tab
    readyTimeData: function (fenceTimes, data) {
      let fenceMoveFromStationTime = '-';
      let fenceArriveToLocationTime = '-';
      let fenceMoveFromLocationTime = '-';
      let fenceArriveToHospitalTime = '-';
      let fenceFinishTime = '-';
      let fenceArriveToStationTime = '-';
      if (fenceTimes) {
        if (fenceTimes.moveFromStationTime) {
          fenceMoveFromStationTime = Vue.moment(fenceTimes.moveFromStationTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToLocationTime) {
          fenceArriveToLocationTime = Vue.moment(fenceTimes.arriveToLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.moveFromLocationTime) {
          fenceMoveFromLocationTime = Vue.moment(fenceTimes.moveFromLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.arriveToHospitalTime) {
          fenceArriveToHospitalTime = Vue.moment(fenceTimes.arriveToHospitalTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.finishTime) {
          fenceFinishTime = Vue.moment(fenceTimes.finishTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToStationTime) {
          fenceArriveToStationTime = Vue.moment(fenceTimes.arriveToStationTime).format('HH:mm:ss');
        }
      }
      let moveFromStationPer = false;
      let arriveToLocationPer = false;
      let moveFromLocationPer = false;
      let arriveToHospitalPer = false;
      let patientDeliveryPer = false;
      let finishPer = false;
      let arriveToStationPer = false;
      this.missionTimes = [];
      let finishTime = '-';
      let arriveToStationTime = '-';
      let patientDeliveryTime = '-';
      let arriveToHospitalTime = '-';
      let moveFromLocationTime = '-';
      let arriveToLocationTime = '-';
      let moveFromStationTime = '-';
      let deliveryTime = '-';
      let pickupTime = '-';
      let ringTime = '-';
      let passedFromCallTime = '-';
      let passedFromDispatchTime = '-';

      if (data.finishTime) {
        finishTime = Vue.moment(data.finishTime).format('HH:mm:ss');
      } else {
        finishPer = true;
      }
      if (data.arriveToStationTime) {
        arriveToStationTime = Vue.moment(data.arriveToStationTime).format('HH:mm:ss');
      } else {
        arriveToStationPer = true;
      }
      if (data.patientDeliveryTime) {
        patientDeliveryTime = Vue.moment(data.patientDeliveryTime).format('HH:mm:ss');
      } else {
        patientDeliveryPer = true;
      }
      if (data.arriveToHospitalTime) {
        arriveToHospitalTime = Vue.moment(data.arriveToHospitalTime).format('HH:mm:ss');
      } else {
        arriveToHospitalPer = true;
      }
      if (data.moveFromLocationTime) {
        moveFromLocationTime = Vue.moment(data.moveFromLocationTime).format('HH:mm:ss');
      } else {
        moveFromLocationPer = true;
      }
      if (data.arriveToLocationTime) {
        arriveToLocationTime = Vue.moment(data.arriveToLocationTime).format('HH:mm:ss');
      } else {
        arriveToLocationPer = true;
      }
      if (data.moveFromStationTime) {
        moveFromStationTime = Vue.moment(data.moveFromStationTime).format('HH:mm:ss');
      } else {
        moveFromStationPer = true;
      }
      if (data.deliveryTime) {
        deliveryTime = Vue.moment(data.deliveryTime).format('HH:mm:ss');
      }
      if (data.pickupTime) {
        pickupTime = Vue.moment(data.pickupTime).format('HH:mm:ss');
      }
      if (data.ringTime) {
        ringTime = Vue.moment(data.ringTime).format('HH:mm:ss');
      }
      this.missionTimes.push(
        {
          title: 'زمان تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: ringTime,
          id: 1,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان پاسخ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: pickupTime,
          id: 2,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان گذشته از تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromCallTime,
          id: 3,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان گذشته از ابلاغ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: passedFromDispatchTime,
          id: 4,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'دریافت ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: deliveryTime,
          id: 5,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'حرکت از پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromStationTime,
          id: 6,
          size: 3,
          per: moveFromStationPer,
          perKey: 'moveFromStation',
          secondText: fenceMoveFromStationTime,
        },
        {
          title: 'رسیدن به فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToLocationTime,
          id: 7,
          size: 3,
          per: arriveToLocationPer,
          perKey: 'arriveToLocation',
          secondText: fenceArriveToLocationTime,
        },
        {
          title: 'حرکت از فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromLocationTime,
          id: 8,
          size: 3,
          per: moveFromLocationPer,
          perKey: 'moveFromLocation',
          secondText: fenceMoveFromLocationTime,
        },
        {
          title: 'رسیدن به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToHospitalTime,
          id: 9,
          size: 3,
          per: arriveToHospitalPer,
          perKey: 'arriveToHospital',
          secondText: fenceArriveToHospitalTime,
        },
        {
          title: 'تحویل به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: patientDeliveryTime,
          id: 10,
          size: 3,
          per: patientDeliveryPer,
          perKey: 'patientDelivery',
          secondText: '',
        },
        {
          title: 'پایان ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: finishTime,
          id: 13,
          size: 3,
          per: finishPer,
          perKey: 'finish',
          secondText: fenceFinishTime,
        },
        {
          title: 'رسیدن به پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToStationTime,
          id: 12,
          size: 3,
          per: arriveToStationPer,
          perKey: 'arriveToStation',
          secondText: fenceArriveToStationTime,
        },

      );
      if (data.ringTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.ringTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromCallInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[2].text = this.msToTime(dd);
        }, 1000);
      }
      if (data.dispatchTime) {
        let date1 = new Date(data.currentTime);
        let date2 = new Date(data.dispatchTime);
        let dd = date1.getTime() - date2.getTime();
        this.passedTimeFromDispatchInterval = setInterval(() => {
          dd = dd + 1000;
          this.missionTimes[3].text = this.msToTime(dd);
        }, 1000);
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;

      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    readyStateData: function (data) {
      this.stateDataTableHeader = [
        { text: 'وضعیت', value: 'state', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.stateDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.stateDataTableItems.push({
          state: data[i].state ? data[i].state : '-',
          date: date,
          note: data[i].note ? data[i].note : '-',
          user: user,
        });
      }
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    //address
    readyAddressLogData: function (data) {
      this.addressDataTableHeader = [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.addressDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.addressDataTableItems.push({
          date: date,
          address: data[i].address ? data[i].address : '-',
          user: user,
        });
      }
    },
    clearSetIntrvals: function () {
      clearInterval(this.mapSingleMovingIconInterval);
    },
    closeMissionDetailModal: function () {
      (this.followUpDashboardDetailTab = 'mission'), (this.missionAddress = '');
      this.missionCheifCompliant = '';
      this.missionCheifCompliantNote = '';
      this.listOfMissionCallerIds = [];
      this.listOfMissionLakeCodeStation = [];
      this.missionTagList = [];
      this.selectedMissionTag = null;
      this.missionTimes = '';
      this.stateDataTableItems = [];
      this.stateDataTableHeader = [];
      clearInterval(this.passedTimeFromCallInterval);
      clearInterval(this.passedTimeFromDispatchInterval);
      clearInterval(this.mapSingleMovingIconInterval);
      this.passedTimeFromCallInterval = null;
      this.passedTimeFromDispatchInterval = null;
      this.noteText = '';
      this.noteList = [];
      this.disabelNoteConfirm = false;
      this.addressDataTableHeader = [];
      this.addressDataTableItems = [];
      this.polyline = {
        latlngs: [],
        color: '#49454F',
      };
      this.phoneOnlineLocationInterval = null;
      this.mapSingleMovingIconInterval = null;
      this.$root.$refs.FollowUpMissionsDashboard.closeDetailModal();
    },
    //other organ
    readyOtherOrganization: function (data) {
      this.otherOrganDataTableHeader = [
        { text: 'عنوان', value: 'title', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
      ];
      this.otherOrganDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].requestDate) {
          date = Vue.moment(data[i].requestDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.otherOrganDataTableItems.push({
          title: data[i].organization ? data[i].organization : '-',
          date: date,
        });
      }
    },
    //admission
    readyAdmissionData: function (data) {
      this.admissionDataTableHeader = [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.admissionDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.admissionDataTableItems.push({
          hospital: data[i].hospital ? data[i].hospital.title : '-',
          date: date,
          user: user,
        });
      }
    },
    //doctor
    readyDoctorData: function (data) {
      this.allDoctorOrders = [];
      for (let i = 0; i < data.length; i++) {
        let patient = '';
        if (data[i].patient) {
          let fName = data[i].patient.firstName ? data[i].patient.firstName : '-';
          let lName = data[i].patient.lastName ? data[i].patient.lastName : '-';
          patient = fName + ' ' + lName;
        }
        this.allDoctorOrders.push({
          patient: patient,
          doctorInfoDataTableHeader: [],
          doctorInfoDataTableItems: [],
          doctorDrugDataTableHeader: [],
          doctorDrugDataTableItems: [],
          doctorOrderDataTableHeader: [],
          doctorOrderDataTableItems: [],
        });
        const mainLength = this.allDoctorOrders.length - 1;
        this.allDoctorOrders[mainLength].doctorInfoDataTableHeader = [
          {
            text: 'تشخیص',
            value: 'dignosis',
            align: 'center',
            sortable: false,
          },
          { text: 'نتیجه', value: 'result', align: 'center', sortable: false },
          { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
          { text: 'پزشک', value: 'doctor', align: 'center', sortable: false },
        ];
        this.allDoctorOrders[mainLength].doctorDrugDataTableHeader = [
          { text: 'نام دارو', value: 'drug', align: 'center', sortable: false },
          { text: 'تعداد', value: 'count', align: 'center', sortable: false },
          {
            text: 'نحوه تجویز',
            value: 'useage',
            align: 'center',
            sortable: false,
          },
          {
            text: 'دستور استفاده',
            value: 'standBy',
            align: 'center',
            sortable: false,
          },
        ];
        this.allDoctorOrders[mainLength].doctorOrderDataTableHeader = [
          {
            text: 'اقدامات درمانی',
            value: 'actions',
            align: 'center',
            sortable: false,
          },
        ];
        let doctor = '';
        if (data[i].doctor) {
          let fName = data[i].doctor.firstName ? data[i].doctor.firstName : '-';
          let lName = data[i].doctor.lastName ? data[i].doctor.lastName : '-';
          doctor = fName + ' ' + lName;
        }
        this.allDoctorOrders[mainLength].doctorInfoDataTableItems.push({
          dignosis: data[i].diagnosis ? data[i].diagnosis : '-',
          result: data[i].result ? data[i].result : '-',
          note: data[i].note ? data[i].note : '-',
          doctor: doctor,
        });
        for (let j = 0; j < data[i].patientDoctorOrders.length; j++) {
          let standBy = 'استفاده شود';
          if (data[i].patientDoctorOrders[j].isStandby) {
            standBy = 'آماده استفاده';
          }
          this.allDoctorOrders[mainLength].doctorDrugDataTableItems.push({
            drug: data[i].patientDoctorOrders[j].drug
              ? data[i].patientDoctorOrders[j].drug.title
              : '-',
            count: data[i].patientDoctorOrders[j].dosage
              ? data[i].patientDoctorOrders[j].dosage
              : '-',
            useage: data[i].patientDoctorOrders[j].drugOrderType
              ? data[i].patientDoctorOrders[j].drugOrderType.title
              : '-',
            standBy: standBy,
          });
        }
        for (let j = 0; j < data[i].patientDoctorActions.length; j++) {
          this.allDoctorOrders[mainLength].doctorOrderDataTableItems.push({
            actions: data[i].patientDoctorActions[j] ? data[i].patientDoctorActions[j].title : '-',
          });
        }
      }
    },
    showLine: function () {
      if (this.missionPhoneId) {
        this.getMissionPhoneLocationsFunction(this.missionPhoneId);
      }
    },
    loadPath: function (data) {
      this.polyline.latlngs = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let temp = [];
          temp.push(data[i].latitude);
          temp.push(data[i].longitude);
          this.polyline.latlngs.push(temp);
        }
      }
    },
    callToPatient: function (number) {
      if (number) {
        let data = {
          missionId: this.missionId,
          missionPhoneId: this.missionPhoneId,
          to: number,
        };
        this.callToPatientFunction(data);
      }
    },
  },
};
